import * as React from 'react';
import Card, {CardProps} from '../Card';
import CardHeader from '../CardHeader';
import AlertIcon from '@material-ui/icons/Error';
import CloseIcon from '@material-ui/icons/Clear';
import IconButton from '../IconButton/IconButton';
import {withStyles, createStyles} from '../styles';
import {Omit, WithStyles, Theme} from '..';
import Collapse from '../Collapse';
import {PropTypes} from '..';
import clsx from 'clsx';
import {TypographyProps} from '../Typography';

export interface AlertProps extends Omit<CardProps, 'classes'> {
  onClose?: React.ReactEventHandler<{}>;
  color?: PropTypes.Color | 'error';
  icon?: React.ReactNode;
}

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1),
    },
    backgroundError: {
      backgroundColor: theme.palette.error.light,
    },
    backgroundSecondary: {
      backgroundColor: theme.palette.secondary.light,
    },
  });

const Alert: React.FunctionComponent<AlertProps & WithStyles<typeof styles>> = ({
  elevation,
  children,
  onClose,
  color,
  classes: {root, backgroundError, backgroundSecondary},
  icon,
  ...props
}) => {
  const open = React.Children.count(children) > 0;
  const backgroundClass = clsx({[backgroundError]: color === 'error', [backgroundSecondary]: color === 'secondary'});
  if (icon === undefined) {
    icon = <AlertIcon color={color} />;
  }
  return (
    <Collapse className={root} in={open}>
      <Card {...props} elevation={open ? elevation : undefined}>
        <CardHeader
          id="cla-alert-header"
          avatar={icon}
          title={children}
          titleTypographyProps={{color, variant: 'body2'} as TypographyProps}
          action={
            onClose ? (
              <IconButton className="cla-close" onClick={onClose}>
                <CloseIcon color={color} />
              </IconButton>
            ) : (
              undefined
            )
          }
          className={backgroundClass}
        />
      </Card>
    </Collapse>
  );
};

Alert.defaultProps = {color: 'error'};

export default withStyles(styles)(Alert);
